import { useEffect, useRef } from "react"

interface InfiniteScrollProps {
  loadMore: () => void
  hasMore: boolean
  loading: boolean
  children: React.ReactNode
}

export default function InfiniteScroll({ loadMore, hasMore, loading, children }: InfiniteScrollProps) {
  const loaderRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!hasMore || loading) return
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) loadMore()
      },
      { threshold: 1 }
    )
    if (loaderRef.current) observer.observe(loaderRef.current)
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current)
    }
  }, [hasMore, loading, loadMore])

  return (
    <div>
      {children}
      <div ref={loaderRef} />
      {loading && (
        <div className="flex justify-center py-4">
          <span className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></span>
        </div>
      )}
    </div>
  )
}